import siteConfig from "@iso/config/site.config";
import {
  getGetRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import { put } from "redux-saga/effects";
import userUrls from "src/infinode/constants/urls/userUrls";
import actions from "./actions";

const { getUser } = userUrls;

const onGetUserRequest = ({ token, id }) =>
  fetch(`${siteConfig.apiUrl}${getUser}${id}`, getGetRequestInfo(token)).then(
    response => response
  );

const onGetUserSuccess = function* (resultBody) {
  if (resultBody.user) {
    yield put({
      type: actions.GET_USER_SUCCESS,
      user: resultBody.user
    });
    return true;
  }
  return false;
};

const getUserRequest = getRequestGeneratorFunction(
  actions.GET_USER_REQUEST,
  actions.GET_USER_ERROR,
  onGetUserRequest,
  onGetUserSuccess
);

export default {
  getUserRequest
};
